import { Button, Text } from '@intigral/shared';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { useDispatch } from 'react-redux';
import { getNewContentRating } from '../../../helpers/common';
import url from '../../../helpers/url';
import { checkShowLockIcon } from '../../../helpers/vod';
import { showUpgradedModal } from '../../../store/reducers/generalConfigurationSlice';
import { __ } from '../../../translations';
import user from '../../../helpers/user';
import { KIDSMODE } from '../../../config/constants';
import { isGuestUser, showGuestPromotionPopup } from '../../../config/guestMode';
import viewEvents from '../../../helpers/viewEvents';

export const useEpoisodeItem = (details) => {
    const dispatch = useDispatch();

    const { paidVsFree } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;
    const isLocked = checkShowLockIcon(details?.subscriptionGuids ?? []) && enableLockIcon;

    const isLockedFunc = (e) => {
        dispatch(showUpgradedModal(true));
    };

    // check if suits rating (guests always intercept in Episode → guest redirect modal instead of play)
    let canPlayContent = false;
    const itemRating: string = details?.ratings?.toUpperCase();
    const currentProfileRating: string = user.getProfile()?.newParentalControl?.toUpperCase();
    if (!isGuestUser(user.getUserInfo()) && itemRating && currentProfileRating) {
        // An array of rating, like this: ["G", "PG", "PG12", "PG15", "R15", "R18"]
        const contentRatingArray = getNewContentRating();

        // If the current profile rating has higher/equal index then it can play the content.
        canPlayContent = contentRatingArray.indexOf(currentProfileRating) >= contentRatingArray.indexOf(itemRating);
    }

    const renderMessage = ({ msgTitle, msgText, msgButtonText, clickURL, onCTAHandler }) => {
        return (
            <>
                <Text as="h2" variant="h2" margin={{ default: '2x', md: '3x' }}>
                    {msgTitle}
                </Text>
                <Text as="p" alignment="center" color="gray" margin={{ default: '2x', md: '4x' }}>
                    {msgText}
                </Text>
                {clickURL && msgButtonText && user.getProfileMode() !== KIDSMODE.KID && (
                    <Button
                        style={{ width: '100%' }}
                        LinkComponent="a"
                        href={clickURL}
                        onClick={(e) => {
                            onCTAHandler();
                        }}
                    >
                        {msgButtonText}
                    </Button>
                )}
            </>
        );
    };

    const getPopupMsg = (msgTitle, msgText, msgButtonText?, clickURL?) => {
        const onCTAHandler = () => undefined;

        const messageComponent = renderMessage({
            msgTitle,
            msgText,
            msgButtonText,
            clickURL,
            onCTAHandler,
        });
        viewEvents.broadcast('openPopup', {
            component: messageComponent,
        });
    };

    const showParentalPopupMessage = () => {
        if (showGuestPromotionPopup()) {
            return;
        }
        getPopupMsg(
            __('livetv_content_not_allowed_title'),
            __('livetv_content_not_allowed_desc'),
            __('parental_control_popup_btn_text'),
            url.route('profile-settings')
        );
    };

    return {
        isLocked,
        isLockedFunc,
        canPlayContent,
        showParentalPopupMessage,
    };
};
